var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5257 36.3313H14.8732C14.4168 36.3313 14.0469 36.7013 14.0469 37.1576C14.0469 37.6139 14.4168 37.9839 14.8732 37.9839H16.5257C16.9821 37.9839 17.352 37.6139 17.352 37.1576C17.352 36.7013 16.9821 36.3313 16.5257 36.3313Z",
    fill: "url(#paint0_linear_144_323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6618 36.3313H19.8309C19.3746 36.3313 19.0046 36.7013 19.0046 37.1576C19.0046 37.6139 19.3746 37.9839 19.8309 37.9839H39.6618C40.1181 37.9839 40.4881 37.6139 40.4881 37.1576C40.4881 36.7013 40.1181 36.3313 39.6618 36.3313Z",
    fill: "url(#paint1_linear_144_323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5257 31.3737H14.8732C14.4168 31.3737 14.0469 31.7436 14.0469 32.1999C14.0469 32.6563 14.4168 33.0262 14.8732 33.0262H16.5257C16.9821 33.0262 17.352 32.6563 17.352 32.1999C17.352 31.7436 16.9821 31.3737 16.5257 31.3737Z",
    fill: "url(#paint2_linear_144_323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6618 31.3737H19.8309C19.3746 31.3737 19.0046 31.7436 19.0046 32.1999C19.0046 32.6563 19.3746 33.0262 19.8309 33.0262H39.6618C40.1181 33.0262 40.4881 32.6563 40.4881 32.1999C40.4881 31.7436 40.1181 31.3737 39.6618 31.3737Z",
    fill: "url(#paint3_linear_144_323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5257 26.4159H14.8732C14.4168 26.4159 14.0469 26.7859 14.0469 27.2422C14.0469 27.6985 14.4168 28.0685 14.8732 28.0685H16.5257C16.9821 28.0685 17.352 27.6985 17.352 27.2422C17.352 26.7859 16.9821 26.4159 16.5257 26.4159Z",
    fill: "url(#paint4_linear_144_323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6618 26.4159H19.8309C19.3746 26.4159 19.0046 26.7859 19.0046 27.2422C19.0046 27.6985 19.3746 28.0685 19.8309 28.0685H39.6618C40.1181 28.0685 40.4881 27.6985 40.4881 27.2422C40.4881 26.7859 40.1181 26.4159 39.6618 26.4159Z",
    fill: "url(#paint5_linear_144_323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5257 21.4581H14.8732C14.4168 21.4581 14.0469 21.8281 14.0469 22.2844C14.0469 22.7407 14.4168 23.1107 14.8732 23.1107H16.5257C16.9821 23.1107 17.352 22.7407 17.352 22.2844C17.352 21.8281 16.9821 21.4581 16.5257 21.4581Z",
    fill: "url(#paint6_linear_144_323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6618 21.4581H19.8309C19.3746 21.4581 19.0046 21.8281 19.0046 22.2844C19.0046 22.7407 19.3746 23.1107 19.8309 23.1107H39.6618C40.1181 23.1107 40.4881 22.7407 40.4881 22.2844C40.4881 21.8281 40.1181 21.4581 39.6618 21.4581Z",
    fill: "url(#paint7_linear_144_323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5257 16.5005H14.8732C14.4168 16.5005 14.0469 16.8705 14.0469 17.3268C14.0469 17.7831 14.4168 18.1531 14.8732 18.1531H16.5257C16.9821 18.1531 17.352 17.7831 17.352 17.3268C17.352 16.8705 16.9821 16.5005 16.5257 16.5005Z",
    fill: "url(#paint8_linear_144_323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6618 16.5005H19.8309C19.3746 16.5005 19.0046 16.8705 19.0046 17.3268C19.0046 17.7831 19.3746 18.1531 19.8309 18.1531H39.6618C40.1181 18.1531 40.4881 17.7831 40.4881 17.3268C40.4881 16.8705 40.1181 16.5005 39.6618 16.5005Z",
    fill: "url(#paint9_linear_144_323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.435 13.1433C45.4309 13.0709 45.4168 12.9994 45.3929 12.9309C45.3838 12.9045 45.3772 12.8789 45.3656 12.8532C45.3255 12.7634 45.2695 12.6814 45.2004 12.6111L33.6324 1.04313C33.5621 0.974029 33.4801 0.918048 33.3903 0.87787C33.3647 0.866302 33.339 0.859692 33.3134 0.850603C33.2443 0.826847 33.1723 0.812387 33.0994 0.807636C33.0854 0.810115 33.0697 0.801025 33.0515 0.801025H9.91547C9.45916 0.801025 9.08919 1.171 9.08919 1.62731V4.10617H4.95776C4.50144 4.10617 4.13147 4.47614 4.13147 4.93246V49.5519C4.13147 50.0082 4.50144 50.3782 4.95776 50.3782H39.6618C40.1181 50.3782 40.4881 50.0082 40.4881 49.5519V45.4205H44.6195C45.0758 45.4205 45.4458 45.0505 45.4458 44.5942V13.1953C45.4458 13.1771 45.4367 13.1614 45.435 13.1433ZM33.8778 3.62197L42.6248 12.369H33.8778V3.62197ZM38.8355 48.7256H5.78404V5.75874H9.08919V44.5942C9.08919 45.0505 9.45916 45.4205 9.91547 45.4205H38.8355V48.7256ZM43.7932 43.7679H10.7418V2.4536H32.2252V13.1953C32.2252 13.6516 32.5952 14.0216 33.0515 14.0216H43.7932V43.7679Z",
    fill: "url(#paint10_linear_144_323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8309 8.23755H14.8732C14.4168 8.23755 14.0469 8.60752 14.0469 9.06384V14.0216C14.0469 14.4779 14.4168 14.8478 14.8732 14.8478H19.8309C20.2872 14.8478 20.6572 14.4779 20.6572 14.0216V9.06384C20.6572 8.60752 20.2872 8.23755 19.8309 8.23755ZM19.0046 13.1953H15.6994V9.89012H19.0046V13.1953Z",
    fill: "url(#paint11_linear_144_323)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_144_323",
    x1: 15.6994,
    y1: 36.3313,
    x2: 15.6994,
    y2: 37.9839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_144_323",
    x1: 29.7464,
    y1: 36.3313,
    x2: 29.7464,
    y2: 37.9839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_144_323",
    x1: 15.6994,
    y1: 31.3737,
    x2: 15.6994,
    y2: 33.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_144_323",
    x1: 29.7464,
    y1: 31.3737,
    x2: 29.7464,
    y2: 33.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_144_323",
    x1: 15.6994,
    y1: 26.4159,
    x2: 15.6994,
    y2: 28.0685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_144_323",
    x1: 29.7464,
    y1: 26.4159,
    x2: 29.7464,
    y2: 28.0685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_144_323",
    x1: 15.6994,
    y1: 21.4581,
    x2: 15.6994,
    y2: 23.1107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_144_323",
    x1: 29.7464,
    y1: 21.4581,
    x2: 29.7464,
    y2: 23.1107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_144_323",
    x1: 15.6994,
    y1: 16.5005,
    x2: 15.6994,
    y2: 18.1531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_144_323",
    x1: 29.7464,
    y1: 16.5005,
    x2: 29.7464,
    y2: 18.1531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_144_323",
    x1: 24.7886,
    y1: 0.801025,
    x2: 24.7886,
    y2: 50.3782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_144_323",
    x1: 17.352,
    y1: 8.23755,
    x2: 17.352,
    y2: 14.8478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.5772,
    height: 49.5772,
    fill: "white",
    transform: "translate(0 0.801025)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument1);
export default __webpack_public_path__ + "static/media/document 1.70fd717b08f581850cfcebfca0111395.svg";
export { ForwardRef as ReactComponent };